import { render, staticRenderFns } from "./mytabs.vue?vue&type=template&id=3b641cf0&scoped=true"
import script from "./mytabs.vue?vue&type=script&lang=js"
export * from "./mytabs.vue?vue&type=script&lang=js"
import style0 from "./mytabs.vue?vue&type=style&index=0&id=3b641cf0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.6_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6._v3ikegxpyohwicxz2xngozg43i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b641cf0",
  null
  
)

export default component.exports